export const selectTechnologiesState = (state) => state.technologies;

export const selectAllTechnologies = (state) =>
  selectTechnologiesState(state).items;

export const selectStackOptions = (state) =>
  selectTechnologiesState(state).items
    .filter((t) => t.type === 'stack')
    .map((t) => ({
      value: t.name,
      label: t.name,
      userId: t.user_id,
      techId: t.tech_id,
    }));

export const selectToolOptions = (state) =>
  selectTechnologiesState(state).items
    .filter((t) => t.type === 'tool')
    .map((t) => ({
      value: t.name,
      label: t.name,
      userId: t.user_id,
      techId: t.tech_id,
    }));
